<template>
  <button
    class="button is-primary"
    v-bind="$attrs"
    @click="launch()"
    :disabled="!client"
  >
    <span class="icon">
      <i class="fab fa-google"></i>
    </span>
    <span>Log in with Google</span>
  </button>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'social-sign-in',
  data() {
    return {
      client: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions("auth", ["authLogin"]),
    init() {
      if (window.google && window.google.accounts) {
        this.initClient();
        return;
      }

      var self = this;
      var script = document.createElement("script");
      script.onload = function () {
        if (!window.google && !window.google.accounts)
        return void (console.error("no Google accounts script included"));
        self.initClient();
      };

      script.async = true;
      script.defer = true;
      script.src = "https://accounts.google.com/gsi/client";
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    initClient() {
      // window.gapi.load('auth2', function () {
      //   window.gapi.auth2.init({
      //     client_id: '959090453719-nipuooakimcomfulvh1pq3pigkefuq0s.apps.googleusercontent.com',
      //     cookiepolicy: 'single_host_origin',
      //     scope: 'profile email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/gmail.readonly'
      //   })
      // })
      this.client = window.google.accounts.oauth2.initCodeClient({
        client_id: '1002275593312-lien5q68pat17448d6sbo8speeh38k40.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
        ux_mode: 'popup',
        callback: (response) => {
          this.$emit('success', response);
          // After recipt, the code is exchanged for an access token and
          // refresh token, and the platform then updates this web app
          // running in user's browser with the requested calendar info.
        }
      });
    },
    launch() {
      this.client.requestCode();
      // var googleAuth = window.gapi.auth2.getAuthInstance();

      // googleAuth.grantOfflineAccess({
      //   scope: 'profile email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/gmail.readonly'
      // }).then(
      //   resp => {
      //     this.$emit('success', resp);
      //   }, (error) => {
      //     this.$emit('error', error);
      //   }
      // );
    }
  }
}
</script>

<style scoped>
.google-signin {
  background-color: #fff !important;
  color: #363E4F;
  text-align: left !important;
}
.fb-signin {
  background-color: #3B5998 !important;
  color: #fff !important;
}
</style>
